import React from 'react';
import { Modal } from 'semantic-ui-react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { CARD_ACTION_TYPES } from '../../../constants/paymentCardConstans';
import styles from './CardActionsModal.module.scss';

const CardActionsModal = (props) => {
  const { openModal, setOpenModal, removeCard, makeDefault, cardHolderId, actionType } = props;
  const { t } = useTranslation();

  const handleConfirm = () => {
    if (actionType === CARD_ACTION_TYPES.DELETE) {
      removeCard(cardHolderId);
    } else {
      makeDefault(cardHolderId);
    }
    setOpenModal(false);
  };

  return (
    <Modal
      onClose={() => setOpenModal(false)}
      onOpen={() => setOpenModal(true)}
      open={openModal}
      closeOnEscape
      size="tiny"
    >
      <Modal.Header>
        <div className={styles.modalHeader}>
          {actionType === CARD_ACTION_TYPES.DELETE ? t('myCards.removeConfirmation') : t('myCards.makeDefaultConfirmation')}
        </div>
      </Modal.Header>
      <Modal.Actions className={styles.buttonContainer}>
        <button type="button" className={styles.cancelButton} onClick={() => setOpenModal(false)}>
          {t('leaveWarningModal.cancel')}
        </button>
        <button type="button" className={styles.confirmButton} onClick={handleConfirm}>
          {t('leaveWarningModal.confirm')}
        </button>
      </Modal.Actions>
    </Modal>
  );
};

CardActionsModal.propTypes = {
  openModal: PropTypes.bool.isRequired,
  setOpenModal: PropTypes.func.isRequired,
  removeCard: PropTypes.func.isRequired,
  makeDefault: PropTypes.func.isRequired,
  cardHolderId: PropTypes.string.isRequired,
  actionType: PropTypes.string.isRequired,
};

export default CardActionsModal;
